<template>
  <div class="page-about">
    <div class="logo">
      <img v-if="operData.wxMchConfigInfo" :src="operData.wxMchConfigInfo.wxLogoUrl | getFilePath" alt="">
    </div>
    <div class="company-desc">
      {{operData.description}}
    </div>
    <div class="contact">
      <div class="qr-code" v-if="operData.wxMchConfigInfo">
        <img :src="operData.wxMchConfigInfo.qrCodeUrl | getFilePath">
        <div>微信公众号</div>
      </div>
      <div class="contact-way">
        <div>电话：{{operData.serviceTel ? operData.serviceTel : operData.tel}}</div>
      </div>
    </div>
    <!-- <div class="copyright">
      <div style="text-align: center">Copyright©珠海派诺科技股份有限公司版权所有</div>
      <div style="text-align: center">粤ICP备1206614号-3</div>
    </div> -->
    <!-- test:
    <wx-open-launch-weapp  id="launch-btn"         
            username="gh_e99fd6692874"          
            path="/pages/index/index.html"
        >       
        <script type="text/wxtag-template">         
            <style>.btn { display: flex;align-items: center;width: 100px;height: 100px }</style>
            <button class="btn">跳转小程序</button>      
            </script>     
        </wx-open-launch-weapp> 

        <button @click="test" style="padding:10px;margin-top:30px">扫码</button> -->
  </div>
</template>

<script>
import {Image, Cell, CellGroup} from 'vant';
import { getOperInfo } from '../../common/api';
// import wxJsSdk from "../../common/location";
export default {
  name: 'about',
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data(){
    return {
      operData: {}
    }
  },
  methods: {
    getOperInfo(){
      getOperInfo({oprPkId: this.$common.get("")}).then(data => {
        if (data.status === this.$config.ajaxStatus) {
          this.operData = data.data[0];
        }
      })
    },
    // test(){
    //   wxJsSdk.scanQRCode2({});
    // }
  },
  mounted() {
    // wxJsSdk.init();
    this.getOperInfo();
  }
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";

.page-about {
  .flex-column();
  align-items: center;
  height: 100%;
  .logo {
    width: 2.09rem;
    height: 2.09rem;
    // background-image: url("../../assets/img/about_logo.png");
    // background-size: 100%,100%;
    border-radius: 0.02rem;
    margin: 0.64rem 0 1rem 0;
    // background-repeat: no-repeat;
    img{
      width: 100%;
      height: 100%;
      border-radius: 0.02rem;
    }
  }
  .company-desc {
    font-size: 0.28rem;
    color:#999999;
    padding: 0 0.2rem;
    text-indent:2em;
  }
  .contact {
    .flex-center();
    color: #999999;
    margin-top: 1.2rem;
    .qr-code {
      font-size: 0.26rem;
      .flex-column();
      align-items: center;
      img {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
    .contact-way {
      margin-left: 0.6rem;
      line-height: 0.6rem;
    }
  }
  .copyright {
    color: #999999;
    font-size: 0.2rem;
    .flex-column();
    flex: 1;
    justify-content: flex-end;
    padding-bottom: 0.2rem;
  }

}
</style>
